import { useEffect, useState } from 'react'
import { BREAKPOINTS } from './use-size-class.ts'

function matchNow(query: string): boolean {
  return typeof window === 'undefined' || !window.matchMedia
    ? false
    : window.matchMedia(query).matches
}

/** Subscribe to a media query. Returns false before first paint, or where there is no matchMedia. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => matchNow(query))

  useEffect(() => {
    // No matchMedia (jsdom, server rendering): nothing to subscribe to.
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** Compact: the phone layout. The single breakpoint everything else derives from. */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.medium - 1}px)`)
}

export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)')
}
